module.exports = __webpack_public_path__ + "static/prestigious-logo-1-21d8596ba423bcd8a83ea82d72ab2d5c.png";